import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12 3.4a8.6 8.6 0 1 0 4.2 16.1c.2-.1.5-.2.7-.1l3.5.9-.6-4.3v-.5c.5-1 .8-2.3.8-3.5 0-4.7-3.9-8.6-8.6-8.6ZM1.4 12a10.6 10.6 0 1 1 20.4 4l.8 5.5a1 1 0 0 1-1.2 1l-4.6-1A10.6 10.6 0 0 1 1.4 12Z"
  />,
  'MessageCircle'
)
